<template>
  <div>
    <v-container fluid>
      <v-row justify="space-around">
        <v-col cols="12" lg="10" class="pa-0">
          <v-form :v-model="true">
            <v-row>
              <v-col cols="12" class="pt-5">
                <v-text-field v-model="dSelectedTask.taskTitle" 
                              :id="('dSelectedTask.taskTitle')" 
                              :disabled="!dEditable"
                              :label="$t('datTableHeader.taskTitle')+'*'"
                              item-color="datPrimary" 
                              color="datPrimary" 
                              hide-details
                              class="mt-0" />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="dSelectedTask.description"  
                            auto-grow 
                            :id="('dSelectedTask.description')" 
                            :disabled="!dEditable" 
                            :label="$t('datGeneric.description')+'*'"
                            item-color="datPrimary" 
                            color="datPrimary" 
                            class="mt-0"
                            hide-details 
                            rows="2" />
              </v-col>              
              <v-col cols="12" md="8">
                <v-text-field v-model="dSelectedTask.responsible" 
                              :id="('dSelectedTask.responsible')" 
                              :disabled="!dEditable"
                              :label="$t('datTableHeader.responsible')+'*'"
                              item-color="datPrimary" 
                              color="datPrimary" 
                              hide-details
                              class="mt-0" />
              </v-col>    
              <v-col cols="12" md="4">
                <v-autocomplete v-model="dSelectedTask.status"
                                :label="$t('datTableHeader.status')+'*'" 
                                :items="dTaskStatus" 
                                :disabled="false"
                                item-value="id" 
                                item-text="description"  
                                item-color="datPrimary" 
                                color="datPrimary" 
                                hide-details 
                                class="mt-0"/>
              </v-col>
              <v-col cols="12" md="6">
                <datDatePicker v-model="dSelectedTask.prevEndDate" 
                              appendIcon= 'mdi-calendar' 
                              :disabled="!dEditable"
                              :label="$t('datTableHeader.prevEndDate')+'*'" />
              </v-col>                        
              <!-- Botón añadir ficheros -->
              <v-col v-if="dFiles.length > 0" cols="12"> 
                <eComplaintFilesTable :pFiles="dFiles" :pShowSnackbar="pShowSnackbar" :pTaskTitle="dSelectedTask.taskTitle" @update="fUpdatedFilesFromTable" />
              </v-col>
              <v-col :class="dFiles.length > 0 ?  'col-12' : 'col-12 col-md-6'" > 
                <v-btn depressed class="datPrimaryBtnOut ma-3" @click="fShowFilesModal">{{$t('btn.addFile')}}</v-btn>    
                <v-btn v-if="dUpdatedFiles" depressed class="datPrimaryBtn ma-3" @click="fAddNewFiles">{{$t('datBtn.save')}}</v-btn>            
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="dSelectedTask.comment"  
                            auto-grow 
                            :id="('dSelectedTask.comment')" 
                            :disabled="false" 
                            :label="$t('datGeneric.comment')"
                            item-color="datPrimary" 
                            color="datPrimary" 
                            hide-details
                            class="mt-0" 
                            rows="2" />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="end" class="pa-4" >
        <v-btn depressed class="datPrimaryBtn ma-3" @click="fClose(false)">
          {{$t('btn.backTo')}}
        </v-btn>
        <v-btn depressed class="datPrimaryBtn ma-3" @click="fSave">
          {{$t('datBtn.save')}}
        </v-btn>
      </v-row>
    </v-container>
    <!-- Componente de subida de ficheros -->
    <datModal v-if="dShowModal" v-model="dShowModal" :pWidth="700" :pTitle="$t('datFormsTitles.filesUpload')">
      <eComplaintFileUpload :pShowSnackbar="pShowSnackbar" 
                            :key="dShowModal" 
                            @close-modal="fAddFilesToComplaint"></eComplaintFileUpload>
    </datModal>     
  </div>
</template>
<script>

// Servicios
import ServiceEcomplaints from '@/services/srv-eComplaints'
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

// Componentes 
import datModal from '@/components/datModal'
import eComplaintFileUpload from '@/components/EComplaints/complaintDetail/modals/eComplaintFileUpload' 
import eComplaintFilesTable from '@/components/EComplaints/complaintDetail/modals/eComplaintFilesTable' 
import datDatePicker from '@/components/datDatePicker'

export default {
  mixins: [mxCanalDenuncias],
  components: {
    datDatePicker,
    eComplaintFileUpload,
    eComplaintFilesTable,
    datModal
  },  

  mounted(){
    if(this.pSelectedTask){
      this.dSelectedTask = this.pSelectedTask
      this.dEditable = false
      this.fGetTaskFiles()
    }
  },

  data () {
    return {
      dSelectedTask: {},
      dEditable: true,
      dUpdatedFiles: false,
      dFiles: [],
      dShowModal: false,
      dManager: localStorage.getItem("manager") ? localStorage.getItem("manager") : 'N',
      dTaskStatus: [ 
        {id: 'PENDIENTE', description: this.$t('datGeneric.pending')},
        {id: 'COMPLETADA', description: this.$t('datGeneric.completed')},
        {id: 'CANCELADA', description: this.$t('datGeneric.canceled')}        
      ]
    }
  },

  props:{
    pSelectedTask:{
      type: Object,
      required: false
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    }, 
    pComplaintId:{
      type: Number,
      required: false
    } 
  },

  methods: {
    // Comprueba que los campos se han rellenado correctamente 
    fCheckValues(){
      let error 
      if(this.fCheckSingleValue(this.dSelectedTask.taskTitle)){
        error = this.$t('datError.noTaskTitle')
      }else if(this.fCheckSingleValue(this.dSelectedTask.description)){
        error = this.$t('datError.noDescription')        
      }else if(this.fCheckSingleValue(this.dSelectedTask.responsible)){
        error = this.$t('datError.noResponsible')
      }else if(this.fCheckSingleValue(this.dSelectedTask.prevEndDate)){
        error = this.$t('datError.prevEndDate')        
      }else if(this.fCheckSingleValue(this.dSelectedTask.status)){
        error = this.$t('datError.noStatus')
      } 
      return error   
    },


    // Guarda o actualiza la tarea 
    fSave(){
      const valueError = this.fCheckValues()

      if(valueError){
        this.fSnackbarError(valueError, this.pShowSnackbar)
      } else if(this.dEditable){
        this.fSetTaskPDA()
      }else{
        this.fUpdateTaskPDA()
      }
    },

    // Guarda la nueva tarea
    fSetTaskPDA(){
      const payload = {
        complaintId: this.pComplaintId,
        taskTitle: this.dSelectedTask.taskTitle,
        prevEndDate: this.dSelectedTask.prevEndDate,
        responsible: this.dSelectedTask.responsible, 
        comment: this.dSelectedTask.comment, 
        description: this.dSelectedTask.description, 
        status: this.dSelectedTask.status,
        files: this.dFiles
      }
      ServiceEcomplaints.setTaskPDA(payload).then((response) =>{
        if (response.statusCode === '200' && response.result !== 'ko'){
          this.fSnackBarSuccess( this.$t('datAlert.createdTask'))
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      }).finally(() =>{
        this.fClose(true)
      })
    },

    // Actualiza el estado o el comentario de la tarea 
    fUpdateTaskPDA(){
      const payload = {
        complaintId: this.dSelectedTask.complaintId,
        taskTitle: this.dSelectedTask.taskTitle,
        responsible: this.dSelectedTask.responsible, 
        comment: this.dSelectedTask.comment, 
        status: this.dSelectedTask.status
      }

      ServiceEcomplaints.updateTaskPDA(payload).then((response) =>{
        if (response.statusCode === '200' && response.result !== 'ko'){
          this.fSnackBarSuccess( this.$t('datAlert.updateTask'))
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      }).finally(() =>{
        this.fClose(true)
      })
    },

    // Llama al ws que añade los ficheros nuevos a una tarea ya introducida
    fAddNewFiles(){
      const payload = {
        complaintId: this.dSelectedTask.complaintId,
        taskTitle: this.dSelectedTask.taskTitle,
        files: this.dFiles
      }
      ServiceEcomplaints.updateTaskFiles(payload).then(response => {
        if (response.statusCode === '200' && response.result !== 'ko'){
          this.fSnackBarSuccess( this.$t('datAlert.filesAdded'))
          this.dUpdatedFiles = false
          this.fGetTaskFiles()
        }
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      })
    },    

    // Recupera los ficheros asociados a la denuncia
    fGetTaskFiles(){
      this.dLoadingFiles = true
      const payload = {
        complaintId: this.dSelectedTask.complaintId,
        taskTitle: this.dSelectedTask.taskTitle
      }
      
      ServiceEcomplaints.getTaskFiles(payload).then(response => {
        this.dFiles = response.dataRes
      }).catch(error => {
        this.fSnackbarError(error, this.pShowSnackbar)
      }).finally(() => {
        this.dLoadingFiles = false
      })     
    },    

    // Actualiza el data con las modificaciones internas del componente de ficheros
    fUpdatedFilesFromTable(files){
      this.dFiles = files
    },

    // Cierra el componente de logs
    fClose(update){
      this.$emit('close', update)
    },

    // Abre o cierra la modal de subida de ficheros
    fShowFilesModal(){
      this.dShowModal = true
    },

    // Añade los ficheros la tabla de ficheros añadidos 
    fAddFilesToComplaint(files){
      this.dShowModal = false
      // Si se han añadido nuevos ficheros cuando la tarea no es nueva, damos opción de actualizar la lista de ficheros (botón)
      if(!this.dEditable){
        this.dUpdatedFiles = true
      }
      this.dFiles = this.dFiles.concat(files) 
    }
  }
}
</script>

 